import styled from 'styled-components';

export const StyledMainContainer = styled.div`
  display: flex;
  gap: 1rem;
  margin-bottom: 4rem;
`;
